import axios from 'axios'

const API_BASE = process.env.VUE_APP_API_BASE || ''

export function getMessages(limit = 30) {
  return axios.get(`${API_BASE}/api/mood/messages`, { params: { limit } })
}

export function addMessage(content) {
  return axios.post(`${API_BASE}/api/mood/add`, { content })
}
